// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"c7b97fa1","456":"c65170d0","462":"8bfa35b2"}[chunkId] + ".chunk.js";
};